<template>
  <PublicView>
    <main class="main">
      <div
        class="site-breadcrumb"
        style="background: url(assets/img/breadcrumb/01.jpg)"
      >
        <div class="container">
          <h2 class="breadcrumb-title">Liên hệ</h2>
        </div>
      </div>

      <div class="contact-area py-120">
        <div class="container">
          <div class="contact-content">
            <div class="row">
              <div class="col-md-3">
                <div class="contact-info">
                  <div class="contact-info-icon">
                    <i class="fal fa-map-marker-alt"></i>
                  </div>
                  <div class="contact-info-content">
                    <h5>Địa chỉ</h5>
                    <p>207 Nguyễn Phúc Chu, P.15, Q.Tân Bình, TP.Hồ Chí Minh</p>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="contact-info">
                  <div class="contact-info-icon">
                    <i class="fal fa-phone"></i>
                  </div>
                  <div class="contact-info-content">
                    <h5>Số điện thoại</h5>
                    <p>+2 123 4565 789</p>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="contact-info">
                  <div class="contact-info-icon">
                    <i class="fal fa-envelope"></i>
                  </div>
                  <div class="contact-info-content">
                    <h5>Email Us</h5>
                    <p>support@azzura.com</p>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="contact-info">
                  <div class="contact-info-icon">
                    <i class="fal fa-clock"></i>
                  </div>
                  <div class="contact-info-content">
                    <h5>Mở cửa</h5>
                    <p>Thứ 2 - Thứ 7 (08:00SA - 05.30CH)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="contact-wrapper">
            <div class="row">
              <div class="col-lg-6 align-self-center">
                <div class="contact-img">
                  <img src="assets/img/contact/01.jpg" alt="" />
                </div>
              </div>
              <div class="col-lg-6 align-self-center">
                <div class="contact-form">
                  <div class="contact-form-header">
                    <h2>Liên Hệ</h2>
                    <p>
                      It is a long established fact that a reader will be
                      distracted by the readable content of a page randomised
                      words which don't look even slightly when looking at its
                      layout.
                    </p>
                  </div>
                  <form
                    method="post"
                    action="assets/php/contact.php.html"
                    id="contact-form"
                  >
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            name="name"
                            placeholder="Your Name"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="email"
                            class="form-control"
                            name="email"
                            placeholder="Your Email"
                            required=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        name="subject"
                        placeholder="Your Subject"
                        required=""
                      />
                    </div>
                    <div class="form-group">
                      <textarea
                        name="message"
                        cols="30"
                        rows="5"
                        class="form-control"
                        placeholder="Write Your Message"
                      ></textarea>
                    </div>
                    <button type="submit" class="theme-btn">
                      Send Message <i class="far fa-paper-plane"></i>
                    </button>
                    <div class="col-md-12 mt-3">
                      <div class="form-messege text-success"></div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="contact-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d692.7581965011203!2d106.6379732201465!3d10.824154161282522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3174d994a50343b7%3A0xdfd675221ae77c8e!2zVGjhuqNtIGzDs3Qgc8OgbiDDtCB0w7QgIzZE!5e0!3m2!1svi!2s!4v1685371103211!5m2!1svi!2s"
          width="600"
          height="450"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </main>
  </PublicView>
</template>

<script>
import PublicView from "@/components/PublicView.vue";
export default {
  mounted() {
    document.querySelector("title").innerText = "Azzura.vn - liên hệ azzura";
  },
  components: { PublicView },
};
</script>